export const GST = "65bdce46597dae44db0e2e75";
export const CUSTOM = "65bdd1642ad230d985fe952c";
export const DISCUSSION = "65bbcb23976790869d30dc4d";
